import { render, staticRenderFns } from "./SideMenuDrive.vue?vue&type=template&id=4a1b9c45&scoped=true&"
import script from "./SideMenuDrive.vue?vue&type=script&lang=js&"
export * from "./SideMenuDrive.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuDrive.vue?vue&type=style&index=0&id=4a1b9c45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1b9c45",
  null
  
)

export default component.exports